// mox-cart-tweaks.js — asegura que el toggle tenga badge
(function () {
  const btn = document.querySelector('.mox-shadow-cart__toggle');
  if (!btn) return;

  if (!btn.querySelector('[data-mox-counter]')) {
    const span = document.createElement('span');
    span.className = 'mox-badge';
    span.setAttribute('data-mox-counter', '0');
    span.setAttribute('aria-hidden', 'true');
    btn.appendChild(span);
  }
})();
